import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../routers/constants";
import { connect } from "react-redux";
import { createLiveCampaign } from "../../../../store/action/liveCampaignAction";

const LiveHeader = (props) => {
   const navigate = useNavigate();
   const { createLiveCampaign, data } = props;
   return (
      <div className="header-live-stream-container app-v2-header-wrapper">
         <div className="header-live-stream-left-side">
            <div className="header-left-side-layout">
               <div className="header-live-stream-title-container">
                  <div className="header-live-stream-title">
                     <div className="wrapper-header-title" title="Livestream bán hàng">
                        <span className="title-header-live-stream">Livestream bán hàng</span>
                     </div>
                  </div>
                  <span className="header-live-stream-sub-title">
                     Gia tăng hiệu suất bán hàng, tự động chốt đơn theo mã sản phẩm.
                     {/* <a href="" className="header-live-stream-sub-title app-btn app-btn-link app-btn-pd-none v-a-base" target="_blank">
                        Xem thêm
                     </a> */}
                  </span>
               </div>
            </div>
         </div>
         <div className="header-live-stream-right-side">
            <Link to={URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_DEFAULT_SETTINGS}>
               <button type="button" className="app-btn app-btn-default">
                  <div className="svg-next-icon mr5 ic-setting-two-line">
                  </div>
                  <span>Cấu hình chung</span>
               </button>
            </Link>
            {data.length > 0 &&
               <button type="button" className="app-btn app-btn-primary ml10" onClick={() => createLiveCampaign(navigate)}>
                  <div className="svg-next-icon mr5 ic-add-outline-2" style={{ maskSize: 18, width: 18, height: 18 }}>
                  </div>
                  <span>Tạo kịch bản</span>
               </button>
            }
         </div>
      </div>
   )
}
const mapStateToProps = () => {
   return {

   }
}
export default connect(mapStateToProps, {
   createLiveCampaign
})(LiveHeader);